<template>
    <router-link :to="to" class="logo">
        <img :src="logo" alt="Voicecasting" />
    </router-link>
</template>

<script>
import logo from '@/assets/horizontal.svg';

export default {
    name: 'Logo',

    props: {
        to: {
            type: String,
            required: false,
            default: '/',
        },
    },

    data: () => ({
        logo,
    }),
};
</script>

<style lang="less" scoped>
.logo {
    pointer-events: all;
    z-index: 10;
    height: 30px;

    img {
        height: 100%;
        width: auto;
    }

    &[disabled] {
        pointer-events: none;
    }
}
</style>
